import { createSelector } from '@ngrx/store';

import * as fromCore from '@core/core-store/core.reducer';
import * as fromReducer from './channels.reducer';

export const selectState = createSelector(
  fromCore.selectState,
  fromCore.getChannels
);

export const selectAll = createSelector(
  selectState,
  fromReducer.getAll
);

export const selectAllNotEmpty = createSelector(
  selectAll,
  (channels) => channels.filter(c => c.newsCount > 0)
);

export const selectEntities = createSelector(
  selectState,
  fromReducer.getEntities
);

export const selectIds = createSelector(
  selectState,
  fromReducer.getIds
);

export const selectTotal = createSelector(
  selectState,
  fromReducer.getTotal
);

export const selectEntityById = createSelector(
  selectEntities,
  fromReducer.getEntityById
);

export const selectEntitiesById = createSelector(
  selectEntities,
  fromReducer.getEntitiesById
);
